import React, { useEffect, useState } from "react";
import { Modal } from "bootstrap";

export default function Footer({ selectedNotice }) {
  useEffect(() => {
    const el = document.getElementById("modalNotiView");
    if (el) {
      const modal = new Modal(el); // ✅ 직접 초기화
      document.querySelectorAll(".tb-tnx-item").forEach((row) => {
        row.addEventListener("click", () => {
          modal.show();
        });
      });
    }
  }, []);
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright">
            {" "}
            &copy; 2025 <b>Matrix</b>
          </div>
          <div className="nk-footer-links">
            <ul className="nav nav-sm">
              <li className="nav-item dropup">
                <a
                  href="#"
                  className="dropdown-toggle dropdown-indicator has-indicator nav-link text-base"
                  data-bs-toggle="dropdown"
                  data-offset="0,10"
                >
                  <span>한국어</span>
                </a>
                <div className="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                  <ul className="language-list">
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/english.png"
                          alt="en"
                          className="language-flag"
                        />
                        <span className="language-name">English</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/china.png"
                          alt="zh"
                          className="language-flag"
                        />
                        <span className="language-name">简体中文</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/kor.png"
                          alt="ko"
                          className="language-flag"
                        />
                        <span className="language-name">한국어</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/jp.png"
                          alt="ja"
                          className="language-flag"
                        />
                        <span className="language-name">日本語</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/thailand.png"
                          alt="th"
                          className="language-flag"
                        />
                        <span className="language-name">ภาษาไทย</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/mongolia.png"
                          alt="mn"
                          className="language-flag"
                        />
                        <span className="language-name">Монгол</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/vietnam.png"
                          alt="vi"
                          className="language-flag"
                        />
                        <span className="language-name">Tiếng Việt</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/brazil.png"
                          alt="pt"
                          className="language-flag"
                        />
                        <span className="language-name">Português</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/ph.png"
                          alt="tl"
                          className="language-flag"
                        />
                        <span className="language-name">Filipino</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/indonesia.png"
                          alt="id"
                          className="language-flag"
                        />
                        <span className="language-name">Bahasa Indonesia</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="language-item">
                        <img
                          src="/images/flags/in.png"
                          alt="in"
                          className="language-flag"
                        />
                        <span className="language-name">हिंदी</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modalNotiView" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {selectedNotice?.subject || "공지 제목"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <p>{selectedNotice?.content}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
